import React, { useEffect, useRef } from 'react';
import _ from 'lodash';

import Tippy from './ReactTippy';
import { DragAndDropSpace, DragSourceAndDropTarget } from './DnDWrapper';
import { IS_PLAN_TAB_FLG, IS_RESULT_TAB_FLG } from '../utilities/constWijmo';

export const HeaderMenu = ({
  goBack,
  confirmUpdate,
  isDisabledUpdate,
  isExistBtnBack = true,
}) => {
  return (
    <div className='master-slide-view__menu'>
      <ul className='btn-menu'>
        {isExistBtnBack && (
          <li className='btn-menu__item'>
            <button className='btn--sub' onClick={goBack}>
              編集をやめる
            </button>
          </li>
        )}
        <li className='btn-menu__item'>
          <button
            className={isDisabledUpdate ? 'btn--disabled' : 'btn--effective'}
            onClick={confirmUpdate}
            disabled={isDisabledUpdate}
          >
            更新
          </button>
        </li>
      </ul>
    </div>
  );
};

export const RowHeader = ({ columnHeaders }) => {
  const getNameHeader = nameColumn => {
    const tdClassName = 'value-table value-table--table__label';
    const divClassName = 'value-table__label';
    return (
      <thead className='table__header'>
        <tr className='table__label'>
          {_.map(nameColumn, (column, index) => {
            return (
              <td className={tdClassName} key={index}>
                <div className={divClassName}>{column}</div>
              </td>
            );
          })}
        </tr>
      </thead>
    );
  };
  return getNameHeader(columnHeaders);
};

export const InputCheckBox = ({ id, name, disabled, used, selectItem }) => {
  return (
    <React.Fragment>
      {disabled ? (
        <Tippy
          duration={10}
          distance={24}
          arrowType='sharp'
          delay={[500, 0]}
          placement='bottom'
          followCursor={true}
          role={`tippy_target_${_.uniqueId()}`}
          html={renderTooltipContent(
            'すでに現場で作業予定・実績が登録されている工種のため、選択を解除できません。'
          )}
        >
          <label htmlFor={id} className='toggle-radius'>
            <input
              type='checkbox'
              id={id}
              name={name}
              checked={used}
              disabled={disabled}
              onClick={selectItem}
            />
            <i className='i-square-disabled i-3x' aria-hidden='true' />
          </label>
        </Tippy>
      ) : (
        <label htmlFor={id} className='toggle-radius'>
          <input
            type='checkbox'
            id={id}
            name={name}
            checked={used}
            disabled={disabled}
            onClick={selectItem}
          />
          <i className='i-square i-3x' aria-hidden='true' />
        </label>
      )}
    </React.Fragment>
  );
};

export const ToolTip = ({ content, value }) => {
  return (
    <Tippy
      duration={10}
      distance={24}
      arrowType='sharp'
      delay={[500, 0]}
      placement='bottom'
      followCursor={true}
      role={`tippy_target_${_.uniqueId()}`}
      html={renderTooltipContent(content)}
    >
      <p className='value-table__txt--7'>{value}</p>
    </Tippy>
  );
};

export const renderTooltipContent = data => {
  const rowStyle = {
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
    maxWidth: '370px',
  };
  return <div style={rowStyle}>{data}</div>;
};

export const DragAndDropWrapper = ({
  columnHeaders,
  listMainWorkTypes,
  listData,
  mainWorkId,
  setMainWorkId,
  resetListSortSubWork,
  onBeginDrag,
  onDropped,
  type,
}) => {
  const isSubWorkType = type === 'sub';
  const mainWorkTypeItem = _.find(
    listMainWorkTypes,
    item => item.id === mainWorkId
  );
  const mainWorkName = _.defaultTo(_.get(mainWorkTypeItem, 'name'), '');
  const wrapperTable = useRef();
  const table = useRef();
  useEffect(
    () => {
      setStyleTable();
    },
    [listMainWorkTypes]
  );
  const setStyleTable = () => {
    const heightWrapperTable = wrapperTable.current.offsetHeight;
    const heightTable = table.current.offsetHeight;
    if (heightTable > heightWrapperTable) {
      table.current.classList.add(
        'ProgressChangeOrderOfWorkTypeDialog__table--scroll'
      );
    }
  };
  return (
    <DragAndDropSpace>
      {isSubWorkType && (
        <div className='ProgressChangeOrderOfWorkTypeDialog__name'>
          <div className='ProgressChangeOrderOfWorkTypeDialog__name-title'>
            大工種: {mainWorkName}
          </div>
          <div className='ProgressChangeOrderOfWorkTypeDialog__name-btn'>
            <button className='btn-text--sm' onClick={resetListSortSubWork}>
              デフォルトの並び順に戻す
            </button>
          </div>
        </div>
      )}
      <div
        className={
          isSubWorkType && 'ProgressChangeOrderOfWorkTypeDialog__table'
        }
        ref={wrapperTable}
      >
        <table className='table' ref={table}>
          <RowHeader columnHeaders={columnHeaders} />
          <tbody>
            {_.map(listData, (data, index) => {
              const { id, name, field_sub_work_types } = data;
              const notHaveSubWork = _.isEmpty(field_sub_work_types);
              return (
                <DragSourceAndDropTarget
                  id={`gateDnD`}
                  index={index}
                  data={listData}
                  onBeginDrag={onBeginDrag}
                  onDropped={onDropped}
                  canDrag={true}
                  canDrop={true}
                  key={`field_item_list_${index}_${id}`}
                >
                  <tr className='table__item'>
                    <td className='value-table'>
                      <button className='btn-icon--sm'>
                        <i className='i-drag--dark i-4x' />
                      </button>
                    </td>
                    <td className='value-table value-table--name'>
                      <ToolTip content={name} value={name} />
                    </td>
                    {!isSubWorkType && (
                      <td className='value-table'>
                        <button
                          className={notHaveSubWork ? 'btn--disabled' : 'btn'}
                          onClick={() => setMainWorkId(id)}
                          disabled={notHaveSubWork}
                        >
                          {notHaveSubWork ? (
                            <ToolTip
                              content='小工種がありません。'
                              value='小工種の並び順変更'
                            />
                          ) : (
                            <p className='value-table__txt--7'>
                              小工種の並び順変更
                            </p>
                          )}
                        </button>
                      </td>
                    )}
                  </tr>
                </DragSourceAndDropTarget>
              );
            })}
          </tbody>
        </table>
      </div>
    </DragAndDropSpace>
  );
};

/**
 * Describe text, status and time of batch
 * @param {string} aggregatedBatchDateTime
 * @param {string} batchStatusText
 * */
export const CompleteBatchStatus = ({
  aggregatedBatchDateTime,
  batchStatusText,
}) => {
  return (
    <span>
      {batchStatusText} {aggregatedBatchDateTime}
    </span>
  );
};

/**
 * Describe text, status and time of batch
 * @param {string} aggregatedBatchDateTime
 * @param {string} batchStatusText
 * */
export const NoHaveBatchStatus = ({
  aggregatedBatchDateTime,
  batchStatusText,
}) => {
  return (
    <span>
      {batchStatusText} {aggregatedBatchDateTime}
    </span>
  );
};

export const TabPanel = ({ setDisplayTab, marginTab }) => {
  const tab = [
    {
      name: '計画',
      type: IS_PLAN_TAB_FLG,
      classBg: 'bg-plan',
    },
    {
      name: '実績',
      type: IS_RESULT_TAB_FLG,
      classBg: 'bg-result',
    },
  ];
  return (
    <div
      style={{ marginLeft: `${marginTab}px` }}
      className='ProgressSchedule--tab'
    >
      {_.map(tab, (item, index) => {
        const { name, type, classBg } = item;
        return (
          <button
            className={`ProgressSchedule--tab__btn ${classBg}`}
            key={index}
            onClick={() => setDisplayTab(type)}
          >
            {name}
          </button>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ProgressBase.jsx